<template>
  <div class="examination_box">
    <iframe :src="src" frameborder="0" class="iframe" id="iframe"></iframe>
    <integralBox
      v-show="!$route.query.integral"
      class="topLeft"
      ref="integralBox"
    ></integralBox>
    <robot
      v-if="showRobot"
      ref="robotBox"
      :goodsId="$route.query.goodsId"
      :bookName="$route.query.bookName"
    />
  </div>
</template>
<script>
import integralBox from "@/components/integralBox.vue";
import robot from "@/components/robot.vue";
import { testURL } from "@/utils/config.js";
export default {
  data() {
    return {
      dictType: "oc_teach_property",
      activeName: "material",
      catalogType: "law_type",
      activeIndex: 0,
      src: "",
      showRobot: false,
    };
  },
  components: { integralBox, robot },
  watch: {
    //监听
    $route(to, from) {},
  },
  created() {
    this.src =
      testURL +
      "/answer?testPaperId=" +
      this.$route.query.testPaperId +
      "&userId=" +
      this.$route.query.userId +
      "&userName=" +
      this.$route.query.userName +
      "&params1=" +
      this.$route.query.goodsId +
      (this.$route.query.showAi ? "&showAi=" + this.$route.query.showAi : "");
  },
  mounted() {
    this.$refs.integralBox.isAddIntegral(); //阅读进度
    window.addEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      if (event.origin == testURL) {
        let data = event.data.data;

        if (data.type == "showAi" && data.code == "success") {
          this.showRobot = true;
        } else if (data.type == "AiAnalysis" && data.code == "success") {
          this.$refs.robotBox.robotShwo = true;
          this.$refs.robotBox.sending(data.value.replace(/&nbsp;/gi, ""));
        }
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.examination_box {
  width: 1450px;
  height: 100vh;
  margin: 0 auto;
}
.iframe {
  width: 100%;
  height: 100%;
}
</style>